/* CUSTOM */

class CartClearButton extends HTMLElement {
  #isDrawer = false;

  connectedCallback() {
    this.#isDrawer = !!this.closest('cart-drawer');
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = async (event) => {
    event.preventDefault();
    const sections = this.#isDrawer ? 'cart-drawer,cart-icon-bubble' : 'main-cart-items,cart-icon-bubble';

    try {
      await fetch(`${routes.cart_url}/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!this.#isDrawer) {
        location.reload();
        return;
      }

      const sectionData = await fetch(`${routes.cart_url}?sections=${sections}`).then((r) => r.json());

      const updateSection = (html, targetSelector, sourceSelector = targetSelector) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const target = document.querySelector(targetSelector);
        const source = doc.querySelector(sourceSelector);
        if (target && source) target.innerHTML = source.innerHTML;
      };

      updateSection(sectionData['cart-drawer'], '#CartDrawer');
      updateSection(sectionData['cart-icon-bubble'], '#cart-icon-bubble', '.shopify-section');

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('is-empty');
        cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => cartDrawer.close());
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: { item_count: 0 } });
    } catch (error) {
      console.error(error);
    }
  };
}
customElements.define('cart-clear-button', CartClearButton);


/* Terms: open link in new window + replace app alert with confirm dialog */
{
  document.addEventListener('DOMContentLoaded', () => {
    const link = document.querySelector('.terms-panikka a');
    if (link) {
      link.setAttribute('target', '_blank');
      link.textContent = window.customTranslations.termsText;
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!btn) return;

    const checkbox = document.querySelector('.pterms-checkbox');
    if (!checkbox || checkbox.checked) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (confirm(window.customTranslations.termsConfirm)) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      btn.click();
    }
  }, true);
}


/* 1-click add to cart for the search dropdown (.ps-atc-button).
   The dropdown markup lives inside the header search <form>, so a real nested
   product <form> would be invalid HTML — these buttons post to the cart
   directly and refresh the cart drawer. See snippets/predictive-add-to-cart. */
function setPredictiveButtonLoading(button, isLoading) {
  const spinner = button.querySelector('.ps-atc-spinner');
  button.classList.toggle('loading', isLoading);
  if (isLoading) {
    button.setAttribute('aria-disabled', 'true');
  } else {
    button.removeAttribute('aria-disabled');
  }
  if (spinner) spinner.classList.toggle('hidden', !isLoading);
}

function addToCartFromPredictiveSearch(button) {
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  setPredictiveButtonLoading(button, true);

  fetch(window.routes.cart_add_url, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error('[predictive-atc] add failed:', response.description || response.message);
        return;
      }
      if (!cart || typeof cart.renderContents !== 'function') return;

      cart.renderContents(response);
      // When the cart was empty, the theme's renderContents only clears
      // `is-empty` on `.drawer__inner`, not on the <cart-drawer> host — so the
      // drawer keeps showing the empty state even though the item was added.
      cart.classList.remove('is-empty');
    })
    .catch((error) => console.error('[predictive-atc]', error))
    .finally(() => setPredictiveButtonLoading(button, false));
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('.ps-atc-button');
  if (!button) return;

  // Stop the click from submitting the search form / selecting the search option.
  event.preventDefault();
  event.stopPropagation();

  if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;
  addToCartFromPredictiveSearch(button);
});

/* END CUSTOM */
